/**
 * The name of a conversation, from the files WhatsApp gives us.
 *
 * Android names the transcript after the chat. iOS always calls it
 * `_chat.txt`, so an iPhone export imported as a conversation literally named
 * "_chat" — fixed in the preview and then missed here, which is how it reached
 * the chat list.
 *
 * Shared deliberately: ingest derives the chat id from this string, so preview
 * and import disagreeing would mean the same export landing as two chats.
 */
export function chatNameFrom(transcriptName: string, zipName?: string): string {
  const strip = (n: string) => n
    .replace(/^.*\//, '')
    .replace(/\.(txt|zip)$/i, '')
    // "… (1).zip" is the same export downloaded twice, not another chat.
    // On an iPhone the title comes from the zip's name, so without this the
    // second copy lands beside the first instead of joining it.
    .replace(/\s*\((\d{1,2})\)$/, '')
    .replace(/^WhatsApp Chat (with|-|–|—)\s*/i, '')
    .replace(/^Conversa do WhatsApp com\s*/i, '')
    .trim();

  const fromTranscript = strip(transcriptName);
  if (fromTranscript && !/^_chat$/i.test(fromTranscript)) return fromTranscript;
  return (zipName && strip(zipName)) || 'Conversation';
}
